/**
 * True when the failure is an intentional abort (deduped GET, navigation, Strict Mode remount).
 * Use before surfacing {@link getApiErrorMessage} in toasts or inline banners.
 */
export function isSilentRequestAbortError(error) {
  if (error == null) return false;
  if (typeof error === "string") {
    const t = error.trim().toLowerCase();
    return (
      t === "request canceled" || t === "request cancelled" || t === "canceled" || t === "cancelled"
    );
  }
  if (typeof error === "object") {
    if (error.canceled === true) return true;
    if (error.code === "ERR_CANCELED" || error.code === "ECONNABORTED") return true;
    if (error.name === "CanceledError" || error.name === "AbortError") return true;
    const m = typeof error.message === "string" ? error.message.trim().toLowerCase() : "";
    if (
      m === "request canceled" ||
      m === "request cancelled" ||
      m === "canceled" ||
      m === "cancelled"
    ) {
      return true;
    }
  }
  return false;
}

/**
 * Extract a user-facing error message from axios errors or thrown values.
 *
 * Standard API error body:
 * { success: false, message, errorCode, statusCode, timestamp, path }
 *
 * Also supports legacy shapes (nested data.message) and network errors (error.message).
 */
export function getApiErrorMessage(error, fallback = "Something went wrong") {
  if (error == null) return fallback;
  if (error?._globalErrorModalShown === true) return "";

  if (typeof error === "string") {
    const s = error.trim();
    return s || fallback;
  }

  if (typeof error === "object") {
    const p = error.payload;
    if (typeof p === "string" && p.trim()) return p.trim();
    if (p != null && typeof p === "object" && typeof p.message === "string" && p.message.trim()) {
      return p.message.trim();
    }
  }

  const data = error.response?.data;

  if (typeof data === "string") {
    const s = data.trim();
    if (s) return s;
  }

  if (data != null && typeof data === "object") {
    const direct =
      data.message ??
      data.errorMessage ??
      (typeof data.error === "string" ? data.error : data.error?.message);
    if (typeof direct === "string" && direct.trim()) {
      return direct.trim();
    }
    const nested = data.data?.message ?? data.data?.errorMessage;
    if (typeof nested === "string" && nested.trim()) {
      return nested.trim();
    }
  }

  const net = error.message;
  if (typeof net === "string" && net.trim()) {
    return net.trim();
  }

  return fallback;
}
